module.exports = __webpack_public_path__ + "assets/table.8654de89.svg";